import { BreakpointObserver, Breakpoints, BreakpointState } from "@angular/cdk/layout";
import { Component, HostListener, OnInit } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { Observable, Subscription } from "rxjs";
import { ApiService } from "src/app/shared/services";
import { ChatService } from "src/app/shared/services/api/chat.service";

@Component({
  selector: "app-cb-inventory",
  templateUrl: "./cb-inventory.component.html",
  styleUrls: ["./cb-inventory.component.less"],
})
export class CbInventoryComponent implements OnInit {
  innerWidth: number;
  statusList: any[] = []; 
  brand: string;
  bpObserver: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Handset
  );
  bpSubscription: Subscription;
  isHandset = false;

  skuInput: string = '';
  skuCache: string[] = [];
  filteredSuggestions: string[] = [];
  showSuggestions: boolean = false;


  constructor(private api: ApiService, private chatService: ChatService, private breakpointObserver: BreakpointObserver,
    private cookie:CookieService,
  ) {
    this.bpSubscription = this.bpObserver.subscribe(
      (handset: BreakpointState) => {
        this.isHandset = handset.matches;
      }
    );
  }

    @HostListener("window:resize")
    onResize() {
      this.innerWidth = this.api.isAdminSidePanelOpened ? window.innerWidth : window.innerWidth+225;

    }

    panelStateChange(){
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 0);
    }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
  }
  search() {

  }
  async getStatus(data: any) {
    await this.api
      .getProductShippingStatus(data.zipcode, this.skuInput, this.brand)
      .then((resp) => {
        if (resp.onlineAvailableMessage) {
          data.status = resp.onlineAvailableMessage;
        } else {
          if (data.retryAttempts < 5) {
            this.getStatus(data);
            data.retryAttempts = data.retryAttempts + 1;
          } else {
            data.status = "Not Found";
          }
        }
      });
  }
 

  // Function to handle SKU search
  searchSKU() {
    if (this.skuInput && !this.skuCache.includes(this.skuInput)) {
      this.skuCache.unshift(this.skuInput); // Add new SKU to the start
      if (this.skuCache.length > 10) {
        this.skuCache.pop(); // Remove oldest SKU if cache exceeds 10
      }
      this.cookie.set('skuSuggestions', JSON.stringify(this.skuCache));
    }
 
    if (this.skuInput) {
      this.chatService.getProductBySku(this.skuInput).then((data) => {
        if (data && data.length > 0) {
          this.brand = data[0].brand;
        }
      });
      this.api.getWareHouseLocations(this.skuInput).subscribe((resp: any) => {
        resp.map((m) => {
          m.status = "Pending";
          m.retryAttempts = 1;
        });
        this.statusList = resp;
        this.statusList.forEach((f) => {
          f.status = "Updating...";
          this.getStatus(f);
        });
      });
      // this.skuInput = '';
      this.showSuggestions = false;
  
    }

  }

  // Function to filter suggestions
  filterSuggestions() {
    if(this.cookie.get('skuSuggestions')){
    let cache:string[] = JSON.parse(this.cookie.get('skuSuggestions')||'')
    this.filteredSuggestions = cache.filter((sku) =>
      sku.toLowerCase().includes(this.skuInput.toLowerCase())
    );
  }
}

  // Function to handle suggestion selection
  selectSuggestion(suggestion: string) {
    this.skuInput = suggestion;
    this.showSuggestions = false;
  }

  // Hide suggestions with a small delay to allow clicks
  hideSuggestions() {
    setTimeout(() => (this.showSuggestions = false), 200);
  }
}
